import ReportContentDialog from './ReportContentDialog';

export default ReportContentDialog;
